import { isDustAmount } from '@exodus/formatting/lib/asset';
import useExchangeBalance from './use-exchange-balance.js';
import useFromWalletAccount from './use-from-wallet-account.js';
import useFromAsset from './use-from-asset.js';
import { useLimitsContext } from '../context/limits.js';
const useIsBalanceExchangeable = () => {
    const [fromAsset] = useFromAsset();
    const [fromWalletAccount] = useFromWalletAccount();
    const { value: limits } = useLimitsContext();
    const balance = useExchangeBalance({
        assetName: fromAsset.name,
        walletAccount: fromWalletAccount,
    });
    if (!limits?.ExactIn) {
        const isDustBalance = balance.isZero || isDustAmount(balance.toDefaultNumber());
        return !isDustBalance;
    }
    return (balance &&
        fromAsset.units.hasOwnProperty(balance.unitName) &&
        fromAsset.units.hasOwnProperty(limits.ExactIn.max.unitName) &&
        balance.lte(limits.ExactIn.max) &&
        balance.gte(limits.ExactIn.min));
};
export default useIsBalanceExchangeable;
